// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg width=%2712%27 height=%2710%27 viewBox=%270 0 12 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 5L4.2 8L11 1%27 stroke=%27white%27 stroke-width=%272%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Warehouse_wrapper__746Wd {
  padding: 20px;
  background: white;
  border-radius: 8px;
}

.Warehouse_tableScroll__Xw7ru {
  max-height: 450px; /* можно подправить под нужную высоту */
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 8px;
  margin-top: 10px;
  border: 1px solid #e0e0e0;
}

/* Опционально: стилизация полосы прокрутки */
.Warehouse_tableScroll__Xw7ru::-webkit-scrollbar {
  width: 6px;
}

.Warehouse_tableScroll__Xw7ru::-webkit-scrollbar-thumb {
  background-color: #1d8752;
  border-radius: 4px;
}


.Warehouse_text__rXqS0 {
    margin-left: 10px;
}

.Warehouse_header__UmqN0 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.Warehouse_roleInput__kEg1d {
  width: 200px;
  height: 30px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px 10px;
}

.Warehouse_terminalAccess__e39B8 {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
}

.Warehouse_permissionTable__4YLSy {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 20px;
}

.Warehouse_permissionTable__4YLSy th,
.Warehouse_permissionTable__4YLSy td {
  border: 1px solid #e0e0e0;
  padding: 8px 12px;
  text-align: center;
  font-size: 14px;
}

.Warehouse_permissionTable__4YLSy td:nth-child(2),
.Warehouse_permissionTable__4YLSy td:nth-child(3),
.Warehouse_permissionTable__4YLSy td:nth-child(4) {
  border-left: none;
  border-right: none;
}

.Warehouse_permissionTable__4YLSy td:nth-child(1){
  border-right: none;
}

.Warehouse_permissionTable__4YLSy td:nth-child(5){
  border-left: none;
}


.Warehouse_permissionTable__4YLSy th:nth-child(2),
.Warehouse_permissionTable__4YLSy th:nth-child(3),
.Warehouse_permissionTable__4YLSy th:nth-child(4) {
  border-left: none;
  border-right: none;
}

.Warehouse_permissionTable__4YLSy th:nth-child(1){
  border-right: none;
}

.Warehouse_permissionTable__4YLSy th:nth-child(5){
  border-left: none;
}



.Warehouse_permissionTable__4YLSy th {
  background: #f5f5f5;
  font-weight: 600;
}

.Warehouse_permissionTable__4YLSy td:first-child {
  text-align: left;
}

/* Кастомные чекбоксы */
.Warehouse_checkboxContainer__vs7Fv {
  display: inline-block;
  position: relative;
  cursor: pointer;
  width: 18px;
  height: 18px;
}

.Warehouse_checkboxContainer__vs7Fv input {
  opacity: 0;
  width: 0;
  height: 0;
}

.Warehouse_customCheckbox__Aav2o {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: white;
  border: 2px solid rgba(29, 135, 82, 1);
  border-radius: 4px;
  transition: all 0.2s ease;
}

.Warehouse_checkboxContainer__vs7Fv input:checked + .Warehouse_customCheckbox__Aav2o {
  background-color: rgba(29, 135, 82, 1);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
}

.Warehouse_saveButton__s9FnQ {
  background-color: black;
  color: white;
  border: none;
  padding: 8px 18px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.Warehouse_saveButton__s9FnQ:hover {
  background-color: #333;
}
.Warehouse_tableScroll__Xw7ru {
  max-height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 8px;
  margin-top: 10px;
  border: 1px solid #e0e0e0;

  /* ДОБАВИ — чтобы sticky работал внутри таблицы */
  position: relative;
}

/* Фиксируем шапку */
.Warehouse_permissionTable__4YLSy thead th {
  position: sticky;
  top: 0;
  background: #f5f5f5;
  z-index: 2;
}

.Warehouse_toast__tAWLM {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%) translateY(100%);
  background: rgba(29, 135, 82, 0.9);
  color: #fff;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  animation: Warehouse_slideUp__2e9Zl 0.5s forwards;
}

@keyframes Warehouse_slideUp__2e9Zl {
  from { transform: translateX(-50%) translateY(100%); opacity: 0; }
  to { transform: translateX(-50%) translateY(0); opacity: 1; }
}

`, "",{"version":3,"sources":["webpack://./src/pages/StaffPages/PositionPanel/Warehouse.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB,EAAE,uCAAuC;EAC1D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;;;EAGE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;;;AAIA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,yDAAsO;EACtO,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;;EAEzB,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,4CAA4C;EAC5C,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,iDAAgC;AAClC;;AAEA;EACE,OAAO,4CAA4C,EAAE,UAAU,EAAE;EACjE,KAAK,yCAAyC,EAAE,UAAU,EAAE;AAC9D","sourcesContent":[".wrapper {\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n}\n\n.tableScroll {\n  max-height: 450px; /* можно подправить под нужную высоту */\n  overflow-y: auto;\n  overflow-x: hidden;\n  border-radius: 8px;\n  margin-top: 10px;\n  border: 1px solid #e0e0e0;\n}\n\n/* Опционально: стилизация полосы прокрутки */\n.tableScroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.tableScroll::-webkit-scrollbar-thumb {\n  background-color: #1d8752;\n  border-radius: 4px;\n}\n\n\n.text {\n    margin-left: 10px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.roleInput {\n  width: 200px;\n  height: 30px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 5px 10px;\n}\n\n.terminalAccess {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 14px;\n}\n\n.permissionTable {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 6px;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.permissionTable th,\n.permissionTable td {\n  border: 1px solid #e0e0e0;\n  padding: 8px 12px;\n  text-align: center;\n  font-size: 14px;\n}\n\n.permissionTable td:nth-child(2),\n.permissionTable td:nth-child(3),\n.permissionTable td:nth-child(4) {\n  border-left: none;\n  border-right: none;\n}\n\n.permissionTable td:nth-child(1){\n  border-right: none;\n}\n\n.permissionTable td:nth-child(5){\n  border-left: none;\n}\n\n\n.permissionTable th:nth-child(2),\n.permissionTable th:nth-child(3),\n.permissionTable th:nth-child(4) {\n  border-left: none;\n  border-right: none;\n}\n\n.permissionTable th:nth-child(1){\n  border-right: none;\n}\n\n.permissionTable th:nth-child(5){\n  border-left: none;\n}\n\n\n\n.permissionTable th {\n  background: #f5f5f5;\n  font-weight: 600;\n}\n\n.permissionTable td:first-child {\n  text-align: left;\n}\n\n/* Кастомные чекбоксы */\n.checkboxContainer {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n}\n\n.checkboxContainer input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.customCheckbox {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 18px;\n  width: 18px;\n  background-color: white;\n  border: 2px solid rgba(29, 135, 82, 1);\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.checkboxContainer input:checked + .customCheckbox {\n  background-color: rgba(29, 135, 82, 1);\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5L4.2 8L11 1' stroke='white' stroke-width='2'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.saveButton {\n  background-color: black;\n  color: white;\n  border: none;\n  padding: 8px 18px;\n  border-radius: 5px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.saveButton:hover {\n  background-color: #333;\n}\n.tableScroll {\n  max-height: 450px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  border-radius: 8px;\n  margin-top: 10px;\n  border: 1px solid #e0e0e0;\n\n  /* ДОБАВИ — чтобы sticky работал внутри таблицы */\n  position: relative;\n}\n\n/* Фиксируем шапку */\n.permissionTable thead th {\n  position: sticky;\n  top: 0;\n  background: #f5f5f5;\n  z-index: 2;\n}\n\n.toast {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%) translateY(100%);\n  background: rgba(29, 135, 82, 0.9);\n  color: #fff;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.2);\n  animation: slideUp 0.5s forwards;\n}\n\n@keyframes slideUp {\n  from { transform: translateX(-50%) translateY(100%); opacity: 0; }\n  to { transform: translateX(-50%) translateY(0); opacity: 1; }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Warehouse_wrapper__746Wd`,
	"tableScroll": `Warehouse_tableScroll__Xw7ru`,
	"text": `Warehouse_text__rXqS0`,
	"header": `Warehouse_header__UmqN0`,
	"roleInput": `Warehouse_roleInput__kEg1d`,
	"terminalAccess": `Warehouse_terminalAccess__e39B8`,
	"permissionTable": `Warehouse_permissionTable__4YLSy`,
	"checkboxContainer": `Warehouse_checkboxContainer__vs7Fv`,
	"customCheckbox": `Warehouse_customCheckbox__Aav2o`,
	"saveButton": `Warehouse_saveButton__s9FnQ`,
	"toast": `Warehouse_toast__tAWLM`,
	"slideUp": `Warehouse_slideUp__2e9Zl`
};
export default ___CSS_LOADER_EXPORT___;
